/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attach': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M7.579 10.78a3.999 3.999 0 01-5.657 0 3.999 3.999 0 010-5.657L6.165.88a2.996 2.996 0 014.242 0 2.996 2.996 0 010 4.243L6.165 9.366a2.006 2.006 0 01-2.829 0 2.006 2.006 0 010-2.829L7.58 2.295l.707.707-4.243 4.242a1.003 1.003 0 000 1.415 1.003 1.003 0 001.415 0L9.7 4.416a2.006 2.006 0 000-2.829 2.006 2.006 0 00-2.828 0L2.629 5.83a2.996 2.996 0 000 4.243 2.996 2.996 0 004.243 0l3.535-3.536.707.707L7.58 10.78z" _fill="#00395C" fill-opacity=".8"/>'
  }
})
